export default __webpack_public_path__ + "static/media/picture_scroll5.55c8e1e4.jpg";